import React, { useEffect, useState, useRef } from 'react';

//infinite scroll handling for prize section

function InfiniteScroll({ setCounter, scrollElementId, stopPoint, children }) {
    const scrollElementRef = useRef(null);

    // Function to increment the number
    const incrementNumber = () => {
        setCounter(prevNumber => prevNumber + 1);
    };


    // Event listener for scroll
    const handleScroll = () => {
        const scrollTop = document.documentElement.scrollTop + 220 || document.body.scrollTop;
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;

        // Check if the user has scrolled to the bottom
        if (scrollTop + windowHeight >= documentHeight) {
            incrementNumber();
        }
    };

    useEffect(() => {
        // Attach scroll event listener
        window.addEventListener('scroll', handleScroll);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (<div>{children}</div>)

}

export default InfiniteScroll;